import * as React from 'react';
import ListItem, {ListItemProps} from '@material-ui/core/ListItem';
import ListItemIcon, {ListItemIconProps} from '@material-ui/core/ListItemIcon';
import ListItemText, {ListItemTextProps} from '@material-ui/core/ListItemText';
import {Omit} from '@material-ui/core';

export interface SelectionDialogItemProps extends Omit<ListItemProps, 'ref'> {
  component?: any; // strangely missing from ListItemProps
  icon?: ListItemIconProps['children'];
  label: ListItemTextProps['primary'];
  secondary?: ListItemTextProps['secondary'];
  id?: string;
}

export default class SelectionDialogItem extends React.PureComponent<SelectionDialogItemProps> {
  render() {
    const {icon, label, secondary, ...props} = this.props;
    return (
      <ListItem button={true as any} {...props}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : undefined}
        <ListItemText primary={label} secondary={secondary} />
      </ListItem>
    );
  }
}
